/* eslint-disable no-unused-vars */
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { format, parseISO } from 'date-fns';
const dateFormat = 'yyyy-MM-dd';

const STORAGE_KEY = '___locache___/payments';

// const formatDate = (date) => {
//   return new Date(format(date, dateFormat)).toISOString().split('T')[0];
// };

const getLocalStorageItem = ({ key, field, initialValue }) => {
  try {
    const item = window.localStorage.getItem(key);
    if (JSON.parse(item)?.[field]) {
      return JSON.parse(item)?.[field];
    }
    if (initialValue) {
      saveLocalStorageItem({ key, field, value: initialValue });
      return getLocalStorageItem({ key, field });
    }
  } catch (error) {
    console.error(error);
    return '';
  }
};

function getLastMonthStart() {
  const date = new Date();
  date.setMonth(date.getMonth() - 1);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

function getLastMonthEnd() {
  const date = new Date();
  date.setDate(1);
  // date.setHours(23, 59, 59, 999);
  date.setDate(0);
  return date;
}

const getLocalStorageObj = ({ key }) => {
  try {
    const item = window.localStorage.getItem(key);
    return item ? JSON.parse(item) : {};
  } catch (error) {
    console.error(error);
    return {};
  }
};

const saveLocalStorageItem = ({ key, field, value }) => {
  const objFromLS = getLocalStorageObj({ key });
  try {
    const updatedValue = { ...objFromLS, [field]: value };
    window.localStorage.setItem(key, JSON.stringify(updatedValue));
  } catch (error) {
    console.error(error);
  }
};

function formatDate(date) {
  return new Date(format(date, dateFormat)).toISOString();
}

function getDaysFromRange(range) {
  if (range === 'Last 7 Days' || range === 'Last 14 Days' || range === 'Last 30 Days') {
    const match = range.match(/Last (\d+) Days/);
    if (match) {
      return parseInt(match[1], 10);
    }
  }
  return false;
}

function createDefaultSelectedDateRange() {
  let periodName = getLocalStorageItem({ key: STORAGE_KEY, field: 'dateRangeName' });

  if (!periodName) periodName = 'This Month';
  let startDate;
  let endDate;

  if (periodName === 'Custom') {
    const dateFrom = getLocalStorageItem({ key: STORAGE_KEY, field: 'dateFrom' });
    const dateTo = getLocalStorageItem({ key: STORAGE_KEY, field: 'dateTo' });
    startDate = formatDate(dateFrom);
    endDate = formatDate(dateTo);
  }
  if (periodName === 'Today') {
    startDate = formatDate(new Date());
    endDate = formatDate(new Date());
  }
  if (periodName === 'Yesterday') {
    const currentDate = new Date();
    const currentDay = currentDate.getDate();
    currentDate.setDate(currentDay - 1);
    startDate = formatDate(currentDate);
    endDate = formatDate(currentDate);
  }
  if (periodName === 'This Week') {
    const startOfWeek = new Date();
    const dayOfWeek = startOfWeek.getDay();
    const diff = startOfWeek.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
    startOfWeek.setDate(diff);
    startDate = formatDate(startOfWeek);
    endDate = formatDate(new Date());
  }
  if (periodName === 'This Month') {
    startDate = formatDate(new Date().setDate(1));
    endDate = formatDate(new Date());
  }
  if (periodName === 'Last Month') {
    const daysCount = getDaysFromRange('Last 30 Days');
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - daysCount);
    startDate = formatDate(currentDate);
    endDate = formatDate(new Date());
  }
  if (periodName === 'Last Full Month') {
    startDate = formatDate(getLastMonthStart());
    endDate = formatDate(getLastMonthEnd());
  }

  if (getDaysFromRange(periodName)) {
    const daysCount = getDaysFromRange(periodName);
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - daysCount);
    startDate = formatDate(currentDate);
    endDate = formatDate(new Date());
  }
  saveLocalStorageItem({
    key: STORAGE_KEY,
    field: 'dateFrom',
    value: startDate,
  });
  saveLocalStorageItem({
    key: STORAGE_KEY,
    field: 'dateTo',
    value: endDate,
  });
  return {
    from: format(parseISO(startDate), dateFormat),
    to: format(parseISO(endDate), dateFormat),
  };
}

const getDefaultState = () => {
  return {
    timePeriod: createDefaultSelectedDateRange(),
    rangeName: 'This Month',
  };
};

const paymentsSlice = createSlice({
  name: 'payments',
  initialState: getDefaultState(),
  reducers: {
    updateTimeRange: (state, action) => {
      state.timePeriod = {
        from: action.payload.from,
        to: action.payload.to,
      };
    },
    updateDateRangeName: (state, action) => {
      state.rangeName = action.payload;
    },
  },
});

export const paymentsActions = paymentsSlice.actions;
export default paymentsSlice.reducer;
